import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export const VoidReasonDialog = ({
  open,
  onClose,
  reason,
  voidedByName,
}: {
  open: boolean;
  onClose: () => void;
  reason: string | null | undefined;
  voidedByName: string | null | undefined;
}) => {
  const { t } = useTranslation('giving');
  const { t: tCommon } = useTranslation();
  const note = reason?.trim();

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) onClose();
      }}
    >
      <DialogContent closeLabel={tCommon('action.close')}>
        <DialogHeader>
          <DialogTitle>{t('contributions.voidReasonTitle')}</DialogTitle>
        </DialogHeader>
        <DialogBody contentClassName="flex flex-col gap-3">
          <p className="whitespace-pre-wrap text-body-sm text-fg">
            {note || t('contributions.voidReasonEmpty')}
          </p>
          {voidedByName ? (
            <p className="text-body-sm text-fg-secondary">
              {t('contributions.voidedBy', { name: voidedByName })}
            </p>
          ) : null}
        </DialogBody>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onClose}>
            {tCommon('action.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
